export default "__VITE_ASSET__92988350__"